<div class="epic-confirmation">
	<div class="epic-confirmation__message">
		<epic-form-field>
			<epic-select
				[isClearVisible]="false"
				[control]="statusForm.formGroup.controls['status']"
				[customSelectedValues]="true">
				<div
					class="epic-select__custom-values"
					selected-values>
					<div class="epic-select__selected">
						<div
							class="epic-select__colour"
							[style.background-color]="
								statusForm.formGroup.controls.status.value?.is_paid
									? 'var(--color__success)'
									: statusForm.formGroup.controls.status.value?.is_partially_paid
										? 'var(--color__warning)'
										: 'var(--color__danger)'
							"></div>
						{{ getItemTranslation(statusForm.formGroup.controls.status.value) }}
					</div>
				</div>
				@for (status of statuses; track status) {
					<epic-option
						[value]="status"
						class="epic_select__option">
						<div class="epic-select__selected">
							<div
								class="epic-select__colour"
								[style.background-color]="
									status?.is_paid
										? 'var(--color__success)'
										: status?.is_partially_paid
											? 'var(--color__warning)'
											: 'var(--color__danger)'
								"></div>
							{{ getItemTranslation(status) }}
						</div>
					</epic-option>
				}
			</epic-select>
		</epic-form-field>
		<div [class.no-active]="!statusForm.formGroup.controls.status.value?.is_paid && !statusForm.formGroup.controls.status.value?.is_partially_paid" class="margin__top--medium row align__center gap--small">
			<epic-checkbox  [control]="statusForm.formGroup.controls.isPaidCash" />
			<span
				class="clickable"
				(click)="statusForm.formGroup.controls.isPaidCash.setValue(!statusForm.formGroup.controls.isPaidCash.value)"
				>{{ textPaidWithCash }}</span>
		</div>
	</div>
	<div class="epic-confirmation__actions">
		<epic-button
			[text]="confirmButtonText"
			[isActive]="!isSubmitting"
			(onClick)="patchData()" />
		<epic-button
			[text]="cancelButtonText"
			[isActive]="false"
			(onClick)="cancelUpdateStatus()" />
	</div>
</div>
